<main class="forgot-container">
  @if (loading()) { <div class="overlay" role="status" aria-label="Cargando"><div class="spinner"></div></div> }
  @if (message()) { <div class="message success" role="status" aria-live="polite">{{ message() }}</div> }
  @if (error()) { <div class="message error" role="alert" aria-live="assertive">{{ error() }}</div> }

  @if (step() === 'email') {
    <form [formGroup]="emailForm" class="card" (submit)="$event.preventDefault(); sendEmail()">
      <div class="brand"><div class="brand-mark" aria-hidden="true">K</div><div class="brand-copy"><strong>Kozaca</strong><span>Portal Financiadores · Backoffice</span></div></div>
      <div class="content">
        <h1>Recuperar acceso</h1>
        <p class="description">Te enviaremos un enlace para restablecer la contraseña a tu correo corporativo.</p>
        <label for="recovery-email">Correo</label>
        <input id="recovery-email" type="email" placeholder="nombre@grupooroño.com.ar" formControlName="email" autocomplete="email" />
        <button class="primary-action" type="submit" [disabled]="loading()">Enviar enlace</button>
        <button type="button" (click)="gotoLogin()" class="back-login-button"><span aria-hidden="true">←</span> Volver a ingresar</button>
      </div>
    </form>
  }

  @if (step() === 'reset') {
    <form [formGroup]="resetForm" class="card" (submit)="$event.preventDefault(); resetPassword()">
      <div class="brand"><div class="brand-mark" aria-hidden="true">K</div><div class="brand-copy"><strong>Kozaca</strong><span>Portal Financiadores · Backoffice</span></div></div>
      <div class="content">
        <h1>Nueva contraseña</h1><p class="description">Elegí una nueva contraseña para volver a ingresar a tu cuenta.</p>
        <label for="new-password">Nueva contraseña</label><input id="new-password" type="password" placeholder="Nueva contraseña" formControlName="password" />
        <label for="confirm-password">Confirmar contraseña</label><input id="confirm-password" type="password" placeholder="Confirmar contraseña" formControlName="password_confirmation" />
        <button class="primary-action" type="submit" [disabled]="loading()">Cambiar contraseña</button>
        <button type="button" (click)="gotoLogin()" class="back-login-button"><span aria-hidden="true">←</span> Volver a ingresar</button>
      </div>
    </form>
  }

  @if (step() === 'success') {
    <section class="card success-card">
      <div class="brand"><div class="brand-mark" aria-hidden="true">K</div><div class="brand-copy"><strong>Kozaca</strong><span>Portal Financiadores · Backoffice</span></div></div>
      <div class="content"><h1>Contraseña actualizada</h1><p class="description">Ya podés iniciar sesión con tu nueva contraseña.</p><button type="button" (click)="gotoLogin()" class="back-login-button">Volver a ingresar</button></div>
    </section>
  }
</main>
